import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  inputTitle: {
    fontSize: 14,
    fontWeight: 600,
  },
}));
